import { Link } from "react-router-dom";
import PageShell from "./_page-shell";

const FAQS = [
  {
    q: "Combien de temps pour livrer un site ?",
    a: "Selon le contenu et le périmètre : une landing page peut être livrée rapidement, une vitrine complète prend davantage de temps. On valide un planning dès le départ.",
  },
  {
    q: "Est-ce que vous faites le SEO ?",
    a: "Oui : structure, performance, SEO technique, et recommandations contenu. Le niveau dépend de l’offre.",
  },
  {
    q: "Pouvez-vous maintenir le site après la mise en ligne ?",
    a: "Oui : corrections, évolutions, mises à jour et suivi.",
  },
];

export default function FaqsPage() {
  return (
    <PageShell
      title="FAQs creation site web"
      subtitle="Reponses rapides aux questions frequentes sur la creation de site web et le SEO."
    >
      <div className="grid gap-4">
        <h2 className="sr-only">Questions frequentes</h2>
        {FAQS.map((item) => (
          <article
            key={item.q}
            className="rounded-2xl border border-white/10 bg-white/[0.03] p-6"
          >
            <h3 className="text-lg font-semibold">{item.q}</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/70">{item.a}</p>
          </article>
        ))}
        <p className="text-sm text-zinc-500">
          Besoin d'une estimation ? Voir les <Link to="/#services">services</Link> ou aller au{" "}
          <Link to="/#contact">formulaire de contact</Link>.
        </p>
      </div>
    </PageShell>
  );
}

